// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LearningUnitEdit
 */
export interface LearningUnitEdit {
    /**
     * 
     * @type {string}
     * @memberof LearningUnitEdit
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LearningUnitEdit
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LearningUnitEdit
     */
    objectives: Array<string>;
    /**
     * Additional metadata
     * @type {object}
     * @memberof LearningUnitEdit
     */
    metadata?: object;
    /**
     * 
     * @type {string}
     * @memberof LearningUnitEdit
     */
    objectType: LearningUnitEditObjectTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LearningUnitEditObjectTypeEnum {
    LessonEdit = 'LessonEdit',
    BlockEdit = 'BlockEdit'
}



